export const TabType = {
    /** 用户 */
    User: 'User',

    /** 企业 */
    Company: 'Company'
}